import { useDisclosure, useWindowSize } from '@/hooks';
import { Button, Typography } from 'antd';
import { useIntl } from 'react-intl';
import TagsAccountsPayableAndReceivableList from './TagsAccountsPayableAndReceivableList';
import TagsAccountsPayableAndReceivableModal from './TagsAccountsPayableAndReceivableModal';
import { initialTabErrors } from '@/pages/SettingsPages/FinancialSettingsPage';
import { Group } from '@/components/_common';

interface Props {
  handleTabError: (key: keyof typeof initialTabErrors) => void;
}

export default function TagsAccountsPayableAndReceivable({}: Props) {
  const intl = useIntl();
  const { width } = useWindowSize();

  const [modalOpened, modalActions] = useDisclosure();

  return (
    <>
      <Group position="between">
        <Typography.Title level={4}>
          {intl.formatMessage({
            id: 'layout.menu.settings.tagsAccountsPayableAndReceivable',
          })}
        </Typography.Title>

        {!(width < 992) && (
          <Button type="primary" onClick={modalActions.open}>
            Criar Etiqueta
          </Button>
        )}
      </Group>

      <Typography.Paragraph style={{ marginTop: '16px' }}>
        Etiquetas responsáveis por ajudar você a identificar suas contas a pagar
        e receber da forma que desejar
      </Typography.Paragraph>

      <TagsAccountsPayableAndReceivableList />

      <TagsAccountsPayableAndReceivableModal
        open={modalOpened}
        onCancel={modalActions.close}
      />
    </>
  );
}
